import { render, staticRenderFns } from "./project_avatar.vue?vue&type=template&id=4edf7bc5"
import script from "./project_avatar.vue?vue&type=script&lang=js"
export * from "./project_avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports